<div class="breadcrumb-button-icon-container cursor-pointer">
  <a class="btn-setting d-flex align-items-center" title="{{titleStringKey | translate}}">
    <i class="icomoon {{iconClass}}"></i>
    <span class="breadcrumb-button-text-visible">
      {{titleStringKey | translate}}
    </span>
  </a>
</div>
